import { CurrencyInr, Plus } from "@phosphor-icons/react"
import { Button, FormInput } from "@vesatogo/grass-core"
import classNames from "classnames"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useAuthorization } from "~/components/AuthorizationProvider"
import { Permission } from "~/constants/Permissions"

export type AssignCreditType = {
  form?: any
  isDisabled?: boolean
  isSubmitted?: boolean
}

export const AssignCredit = ({
  form,
  isDisabled = false,
  isSubmitted = false,
}: AssignCreditType) => {
  const { getInputProps, values: state } = form
  const { id } = useParams()
  const isNew = id === "new"
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (isNew || state?.is_verified) {
      return setShow(false)
    }
    setShow(true)
  }, [isNew])
  const canApprove = useAuthorization(Permission.canApproveCredit)

  function inputProps(key) {
    return {
      ...getInputProps(key),
      disabled: canApprove ? false : isDisabled,
    }
  }
  return (
    <>
      <section id="assign_limit">
        <header className="border-b-1 border-gray-300 p-3 flex justify-between bg-gray-200">
          <div className="flex gap-1 items-center text-green ">
            Assign Credit Limit
          </div>
          <div>
            <Button
              size="sm"
              hidden={show}
              text="Credit Limit"
              leftIcon={<Plus />}
              variant="outline"
              onClick={() => {
                setShow(true)
              }}
              intent={
                isSubmitted &&
                (!state?.credit_limit ||
                  !state?.payment_cycle_days ||
                  !state?.validity)
                  ? "danger"
                  : "primary"
              }
            />
          </div>
        </header>
        <div
          className={classNames("min-h-[20px] ", show ? "hidden" : "")}
        ></div>
        <div
          className={classNames(
            "p-4 min-h-[10px] grid grid-cols-3 gap-3",
            show ? "" : "hidden"
          )}
        >
          <FormInput
            label="Credit Limit Amt"
            required
            leftElement={<CurrencyInr />}
            {...inputProps("requested_total_amount")}
            error={
              isSubmitted && !state?.requested_total_amount
                ? "Please Enter Credit Limit"
                : ""
            }
          />
          <FormInput
            label="Validity Days"
            required
            {...inputProps("requested_validity")}
            rightElement={<p className="mx-2 text-brown-300 text-sm">Days</p>}
            error={
              isSubmitted && !state?.requested_validity
                ? "Please Enter Validity Days"
                : ""
            }
          />
          <FormInput
            label="Payment Cycle Days"
            required
            {...inputProps("requested_payment_cycle_days")}
            rightElement={<p className="mx-2 text-brown-300 text-sm">Days</p>}
            error={
              isSubmitted && !state?.requested_payment_cycle_days
                ? "Please Enter Payment Cycle Days"
                : ""
            }
          />
        </div>
      </section>
    </>
  )
}
